const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1400&q=80`;

export const IMAGES = {
  hero: u("photo-1542744173-8e7e53415bb0"),
  whiteboard: u("photo-1557804506-669a67965ba0"),
  tablet: u("photo-1748609160056-7b95f30041f0"),
  analyst: u("photo-1763038311036-6d18805537e5"),
  team: u("photo-1581090698407-7d93959da202"),
};

export const CONTACT = {
  email: "[hello@yourdomain.com]",
  phone: "[+00 000 000 0000]",
  address: "[Office address, City, Country]",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "Contact", to: "/contact" },
];

export const OUTCOMES = [
  { k: "01", title: "Cultivate relationships", text: "Understand what keeps new and existing customers loyal, and what quietly pushes them away." },
  { k: "02", title: "Sharpen differentiation", text: "Map where you win against competitors and build a defensible competitive advantage." },
  { k: "03", title: "Evaluate offerings", text: "Test products, services and concepts with the people who will actually buy them." },
  { k: "04", title: "Refine strategy", text: "Turn evidence into a marketing strategy your team can act on with confidence." },
];

export const SERVICES = [
  {
    slug: "quantitative",
    title: "Quantitative Research",
    short: "Online, CATI and face-to-face surveys designed for statistically robust answers.",
    points: ["Questionnaire design", "Sampling strategy", "Usage & attitude studies", "Brand tracking"],
  },
  {
    slug: "qualitative",
    title: "Qualitative Research",
    short: "Focus groups, in-depth interviews and ethnography that uncover the why behind behaviour.",
    points: ["Focus group discussions", "In-depth interviews", "Online communities", "Moderation & transcripts"],
  },
  {
    slug: "b2b",
    title: "B2B & Expert Interviews",
    short: "Hard-to-reach decision makers and domain experts, recruited and interviewed with care.",
    points: ["C-suite & IT decision makers", "Healthcare professionals", "Expert network calls", "Recruitment screening"],
  },
  {
    slug: "operations",
    title: "Research Operations",
    short: "Survey programming, hosting, panel and sample management for research teams who need a reliable engine.",
    points: ["Survey programming & hosting", "Panel & sample management", "Fieldwork project management", "Quality control checks"],
  },
  {
    slug: "analytics",
    title: "Data Processing & Analytics",
    short: "Clean data, tabulations and advanced analytics, delivered fast and checked twice.",
    points: ["Data cleaning & coding", "Cross tabulations", "Conjoint & MaxDiff", "Dashboards & charting"],
  },
  {
    slug: "consulting",
    title: "Strategic Consultancy",
    short: "Domain experts who translate findings into decisions on positioning, pricing and growth.",
    points: ["Market entry & sizing", "Competitive intelligence", "Pricing research", "Go-to-market strategy"],
  },
];

export const PROCESS = [
  { n: "01", title: "Scope", text: "We frame the business question, audience and success criteria with your team." },
  { n: "02", title: "Design", text: "Methodology, sampling and instruments built for accuracy and budget." },
  { n: "03", title: "Field", text: "Execution with real-time quality checks across every respondent." },
  { n: "04", title: "Insight", text: "Analysis, storytelling and a clear set of actions you can take next." },
];

export const INDUSTRIES = [
  { key: "tech", name: "Technology & SaaS", text: "Buyer journeys, feature prioritisation and churn diagnosis for software and hardware brands.", cases: ["Product-market fit", "Feature prioritisation", "Win / loss analysis"] },
  { key: "health", name: "Healthcare & Pharma", text: "Patient and physician research handled with the sensitivity the sector requires.", cases: ["HCP interviews", "Patient journeys", "Launch readiness"] },
  { key: "retail", name: "Retail & E-commerce", text: "Shopper behaviour, store and digital experience research that lifts conversion.", cases: ["Shopper missions", "Customer satisfaction", "Assortment testing"] },
  { key: "finance", name: "Financial Services", text: "Trust, adoption and switching drivers for banks, insurers and fintech.", cases: ["Customer experience", "Product adoption", "Brand health"] },
  { key: "fmcg", name: "FMCG & Consumer", text: "Concept, pack and price testing that de-risks every launch.", cases: ["Concept testing", "Pack testing", "Price elasticity"] },
  { key: "auto", name: "Automotive & Mobility", text: "From EV readiness to dealer experience, insight across the ownership cycle.", cases: ["Purchase drivers", "Dealer audits", "EV adoption"] },
];

export const MARQUEE = ["Market Research Operations", "Consumer Insight", "Competitive Intelligence", "B2B Expert Panels", "Brand Health", "Concept Testing", "Pricing Research", "Strategy Consultancy"];
